import React from 'react'
import {translate} from 'react-i18next'
import styled from 'styled-components'

import EmailVerifiedSuccessDefaultMessage from 'apps/consent-app/email-verified/EmailVerifiedSuccessMessage'
import theme from 'theme'
import Link from 'components/Link'
import View from 'components/View'
import Title from 'components/Title'
import Note from 'components/Note'
import ButtonView from 'components/button/ButtonView'
import DefaultButtonText from 'components/button/ButtonText'
import ButtonSpinner from 'components/button/ButtonSpinnerDot'
import {getLoginCase} from 'utils/stringUtils'
import {isProd} from 'utils/envUtils'
import {LOGIN_CASES} from 'const'

const getFontBoldFamily = props => props.theme.font.boldFamily

const StyledButtonView = styled(ButtonView)`
  font-family: ${getFontBoldFamily};
`

const StyledButtonText = styled(DefaultButtonText)`
  font-family: inherit;
  position: relative;
`

const LinkWrapper = styled(Link)`
  margin-top: 8px;
`

const EmailVerifiedSuccessSummitsMessage = ({t}) => (
  <View>
    <Title>{t('email-verified.title-summits')}</Title>
    <Note>{t('email-verified.subtitle-summits')}</Note>
    <Note light>{t('email-verified.message-summits')}</Note>
  </View>
)

const EmailVerifiedSuccessTrophyMessage = ({t, loginCase, handleClick, loading}) => {
  const linkPrefix = isProd() ? '' : 's.'
  const data = {
    [LOGIN_CASES.BLICK.SKI_TROPHY_GAME]: {
      message: 'email-verified.message-ski-trophy',
      linkText: 'email-verified.ski-trophy-link',
      link: `https://${linkPrefix}skitrophy.ws.blick.ch/`,
    },
    [LOGIN_CASES.BLICK.MEDAILLEN_TROPHY_GAME]: {
      message: 'email-verified.message-medaillen-trophy',
      linkText: 'email-verified.medaillen-trophy-link',
      link: `https://${linkPrefix}skitrophy.ws.blick.ch/olympia`,
    },
    [LOGIN_CASES.BLICK.ICEHOCKEY_GAME]: {
      message: 'email-verified.message-icehockey',
      linkText: 'email-verified.icehockey-link',
      link: `https://${linkPrefix}skitrophy.ws.blick.ch/icehockey`,
      portraitWidth: 'calc(60%)',
    },
    [LOGIN_CASES.BLICK.EM_2022_GAME]: {
      message: 'email-verified.message-em2022-trophy',
      linkText: 'email-verified.em2022-trophy-link',
      link: `https://${linkPrefix}trophy.blick.ch/`,
    },
    [LOGIN_CASES.BLICK.ESAF_2022_GAME]: {
      message: 'email-verified.message-trophy',
      linkText: 'email-verified.trophy-link',
      link: `https://${linkPrefix}trophy.blick.ch/schwingen`,
    },
    [LOGIN_CASES.BLICK.SKI_TROPHY_2223_GAME]: {
      message: 'email-verified.message-trophy',
      linkText: 'email-verified.trophy-link',
      link: `https://${linkPrefix}trophy.blick.ch/skitrophy`,
    },
    [LOGIN_CASES.BLICK.UNIHOCKEY_WM_2022_GAME]: {
      message: 'email-verified.message-trophy',
      linkText: 'email-verified.trophy-link',
      link: `https://${linkPrefix}trophy.blick.ch/unihockeywm`,
    },
    [LOGIN_CASES.BLICK.SOCCER_WM_2022_GAME]: {
      message: 'email-verified.message-trophy',
      linkText: 'email-verified.trophy-link',
      link: `https://${linkPrefix}trophy.blick.ch/wmtrophy`,
    },
    [LOGIN_CASES.BLICK.JACKPOT_2023_GAME]: {
      message: 'email-verified.message-trophy',
      linkText: 'email-verified.jackpot-link',
      link: 'https://jackpot.blick.ch/',
    },
    [LOGIN_CASES.BLICK.EISHOCKEY_WM_2023_GAME]: {
      message: 'email-verified.message-trophy',
      linkText: 'email-verified.trophy-link',
      link: `https://${linkPrefix}trophy.blick.ch/eishockeywm`,
    },
  }
  const {message, linkText, link, portraitWidth} = data[loginCase]

  return (
    <View>
      <Title>{t('email-verified.title-ski-medaillen-trophy')}</Title>
      <Note light>{t(message)}</Note>
      <LinkWrapper
        to={link}
        rel="noopener noreferrer"
        onClick={handleClick && handleClick(link)}
        loading={loading}
        external>
        <StyledButtonView portraitWidth={portraitWidth} {...theme.buttons.primary}>
          {loading ? <ButtonSpinner /> : <StyledButtonText styles={{}}>{t(linkText)}</StyledButtonText>}
        </StyledButtonView>
      </LinkWrapper>
    </View>
  )
}

const EmailVerifiedSuccessMessage = ({t, handleClick, loading}) => {
  const loginCase = getLoginCase(window.location.search)

  switch (loginCase) {
    case LOGIN_CASES.BLICK.SUMMITS:
      return <EmailVerifiedSuccessSummitsMessage t={t} />
    case LOGIN_CASES.BLICK.SKI_TROPHY_GAME:
    case LOGIN_CASES.BLICK.MEDAILLEN_TROPHY_GAME:
    case LOGIN_CASES.BLICK.ICEHOCKEY_GAME:
    case LOGIN_CASES.BLICK.EM_2022_GAME:
    case LOGIN_CASES.BLICK.ESAF_2022_GAME:
    case LOGIN_CASES.BLICK.SKI_TROPHY_2223_GAME:
    case LOGIN_CASES.BLICK.UNIHOCKEY_WM_2022_GAME:
    case LOGIN_CASES.BLICK.SOCCER_WM_2022_GAME:
    case LOGIN_CASES.BLICK.JACKPOT_2023_GAME:
    case LOGIN_CASES.BLICK.EISHOCKEY_WM_2023_GAME:
      return (
        <EmailVerifiedSuccessTrophyMessage t={t} loginCase={loginCase} handleClick={handleClick} loading={loading} />
      )
    default:
      return <EmailVerifiedSuccessDefaultMessage handleClick={handleClick} loading={loading} />
  }
}

export default translate()(EmailVerifiedSuccessMessage)
